import { initLandingAnchors } from '../lib/anchorScroll'

// The landing page is server-rendered ERB — see views/landing/_marketing. The
// only thing JavaScript adds is the eased scroll between its sections, and
// with it off the anchors are ordinary #fragment links that the browser jumps
// to. That is the whole of the enhancement, and the whole of the acceptance:
// this page has to work without it.
initLandingAnchors()
